import {inject, NgModule} from '@angular/core';
import {ActivatedRouteSnapshot, RouterModule, Routes} from '@angular/router';
import {AppSettingsResolver} from '@core/resolvers/app-settings.resolver';
import {PagesGuard} from '@core/guard/pages.guard';
import {Search_pageComponent} from "@app/pages/search_page/search_page.component";
import {CategoryViewComponent} from "@app/pages/home/categories-items/category-view/category-view.component";
import {CatalogService} from "@core/services/catalog/catalog.service";
import {GeneralService} from "@core/services/general/general.service";
import {map} from "rxjs/operators";

const APP_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/layout.component').then((m) => m.LayoutComponent),
    resolve: {
      appSettings: AppSettingsResolver,
    },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home' },
      {
        path: 'home',

        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
        data: { name: 'home' },


      },
      {
        path: 'category/:id',
        loadComponent: () =>
          import('./pages/home/categories-items/category-view/category-view.component').then((m) => m.CategoryViewComponent),
        data: { name: 'categories' },
        resolve:{
          id:(route:ActivatedRouteSnapshot) =>{
        const catalogService=inject(CatalogService)
           let  category=catalogService.currentCatalog$.value ? catalogService.currentCatalog$.value : {
             Id: 0,
             Name: 'string',
             Image: 'string',
             Categories:[]
           }
            category.Id=route.params['id']
            catalogService.currentCatalog$.next(category)
      }
          // const catalogService:inject(CatalogService)
          // const categoryId=catalogService.
        }
      },
      // {
      //   path: 'search-result',
      //   loadComponent: () =>
      //     import('./pages/search_page/search_page.component').then((m) => m.Search_pageComponent),
      //   data: { name: 'home' },
      // },
      {
        path: 'item-details/:itemId',
        loadComponent: () =>
          import('./pages/product-details/product-details.component').then(
            (m) => m.CouponDetailsComponent
          ),
        data: { name: 'item-details/' },
      },
      {
        path: 'products/:categoryId',
        pathMatch: 'full',
        loadComponent: () =>
          import('./pages/home/product-list/product-list.component').then(
            (m) => m.ProductListComponent
          ),
        data: { name: 'products/' },
      },
      {
        path: 'order-summary',
        loadComponent: () =>
          import('./pages/order-summary/order-summary.component').then(
            (m) => m.OrderSummaryComponent
          ),
        data: { name: 'order-summary' },
      },
      {
        path: 'wish-list',
        canActivate: [PagesGuard],
        loadComponent: () =>
          import('./pages/wishlist/wishlist.component').then(
            (m) => m.WishlistComponent
          ),
        data: { name: 'wish-list' },
      },
      {
        path: 'coupons',
        canActivate: [PagesGuard],
        loadComponent: () =>
          import('./pages/coupons/coupons.component').then(
            (m) => m.CouponsComponent
          ),
        data: { name: 'coupons' },
      },
      {
        path: 'order-details/:id',
        loadComponent: () =>
          import('./pages/order-details/order-details.component').then(
            (m) => m.OrderDetailsComponent
          ),
        data: { label: 'OrderDetails', name: 'order-details/' },
      },
      {
        path: 'thank-you',
        loadComponent: () =>
          import('./pages/order-details/order-details.component').then(
            (m) => m.OrderDetailsComponent
          ),
        data: { label: 'ThankYou', name: 'thank-you' },
      },
      {
        path: 'orders',
        canActivate: [PagesGuard],
        loadComponent: () =>
          import('./pages/orders/orders.component').then(
            (m) => m.OrdersComponent
          ),
        data: { label: 'ThankYou', name: 'orders' },
      },
      {
        path: 'account',
        canActivate: [PagesGuard],
        pathMatch: 'prefix',
        loadComponent: () =>
          import('./pages/auth/account/account.component').then(
            (m) => m.AccountComponent
          ),
        data: { name: 'account' },
        children: [
          { path: '', pathMatch: 'full', redirectTo: 'edit' },
          {
            path: 'edit',
            loadComponent: () =>
              import('./pages/auth/account/edit/edit.component').then(
                (m) => m.EditComponent
              ),
          },
          {
            path: 'change-password',
            loadComponent: () =>
              import(
                './pages/auth/account/change-password/change-password.component'
              ).then((m) => m.ChangePasswordComponent),
          },
        ],
      },
      {
        path: 'notifications',
        canActivate: [PagesGuard],
        loadComponent: () =>
          import('./pages/notifications/notifications.component').then(
            (m) => m.NotificationsComponent
          ),
        data: { name: 'notifications' },
      },
      {
        path: 'search',
        loadComponent: () =>
          import('./pages/search/search.component').then(
            (m) => m.SearchComponent
          ),
        data: { name: 'search' },
      },
      {
        path: 'about',
        loadComponent: () =>
          import('./pages/menu/about/about.component').then(
            (m) => m.AboutComponent
          ),
        data: { name: 'about' },
      },
      {
        path: 'contact',
        loadComponent: () =>
          import('./pages/menu/contact/contact.component').then(
            (m) => m.ContactComponent
          ),
        data: { name: 'contact' },
      },
      {
        path: 'privacy',
        loadComponent: () =>
          import('./pages/menu/privacy/privacy.component').then(
            (m) => m.PrivacyComponent
          ),
        data: { name: 'privacy' },
      },
      {
        path: 'terms',
        loadComponent: () =>
          import(
            './pages/menu/terms-conditions/terms-conditions.component'
          ).then((m) => m.TermsConditionsComponent),
        data: { name: 'terms' },
      },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
        data: { name: 'login' },
      },
      {
        path: 'confirm',
        loadComponent: () =>
          import('./pages/auth/confirm/confirm.component').then(
            (m) => m.ConfirmComponent
          ),
        data: { name: 'confirm' },
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./pages/auth/forget-password/forget-password.component').then(
            (m) => m.ForgetPasswordComponent
          ),
        data: { name: 'forget-password' },
      },
      {
        path: 'new-password',
        loadComponent: () =>
          import('./pages/auth/new-password/new-password.component').then(
            (m) => m.NewPasswordComponent
          ),
        data: { name: 'new-password' },
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./pages/auth/register/register.component').then(
            (m) => m.RegisterComponent
          ),
        data: { name: 'register' },
      },
    ],
  },
  {
    path: 'auth',
    data: { name: 'auth' },
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'login' },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
      {
        path: 'confirm',
        loadComponent: () =>
          import('./pages/auth/confirm/confirm.component').then(
            (m) => m.ConfirmComponent
          ),
      },
      {
        path: 'forget-password',
        loadComponent: () =>
          import('./pages/auth/forget-password/forget-password.component').then(
            (m) => m.ForgetPasswordComponent
          ),
      },
      {
        path: 'new-password',
        loadComponent: () =>
          import('./pages/auth/new-password/new-password.component').then(
            (m) => m.NewPasswordComponent
          ),
      },
      {
        path: 'register',
        loadComponent: () =>
          import('./pages/auth/register/register.component').then(
            (m) => m.RegisterComponent
          ),
      },
    ],
  },
  {
    path: '**',
    loadComponent: () =>
      import('./pages/not-found/not-found.component').then(
        (m) => m.NotFoundComponent
      ),
    data: { name: 'not-found' },
  },
];

/*@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})*/
//export class AppRoutingModule {}
export default APP_ROUTES;

